/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { FormSectionResponse } from './FormSectionResponse';
import {
    FormSectionResponseFromJSON,
    FormSectionResponseFromJSONTyped,
    FormSectionResponseToJSON,
    FormSectionResponseToJSONTyped,
} from './FormSectionResponse';
import type { FormGroupResponse } from './FormGroupResponse';
import {
    FormGroupResponseFromJSON,
    FormGroupResponseFromJSONTyped,
    FormGroupResponseToJSON,
    FormGroupResponseToJSONTyped,
} from './FormGroupResponse';

/**
 * 
 * @export
 * @interface InspectionFormResponse
 */
export interface InspectionFormResponse {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    scheduleId?: string;
    /**
     * 
     */
    snapshotId?: string;
    /**
     * 
     */
    templateId?: string;
    /**
     * 
     */
    versionId?: string;
    /**
     * 
     */
    machineId?: string;
    /**
     * 
     */
    status?: InspectionFormResponseStatusEnum;
    /**
     * 
     */
    assignedOperatorId?: string;
    /**
     * 
     */
    generatedAt?: Date;
    /**
     * 
     */
    dueAt?: Date;
    /**
     * 
     */
    completedAt?: Date;
    /**
     * 
     */
    sections?: Array<FormSectionResponse>;
    /**
     * 
     */
    groups?: Array<FormGroupResponse>;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const InspectionFormResponseStatusEnum = {
    Pending: 'PENDING',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Overdue: 'OVERDUE',
    Cancelled: 'CANCELLED',
} as const;
export type InspectionFormResponseStatusEnum = typeof InspectionFormResponseStatusEnum[keyof typeof InspectionFormResponseStatusEnum];


/**
 * Check if a given object implements the InspectionFormResponse interface.
 */
export function instanceOfInspectionFormResponse(value: object): value is InspectionFormResponse {
    return true;
}

export function InspectionFormResponseFromJSON(json: any): InspectionFormResponse {
    return InspectionFormResponseFromJSONTyped(json, false);
}

export function InspectionFormResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionFormResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'scheduleId': json['scheduleId'] == null ? undefined : json['scheduleId'],
        'snapshotId': json['snapshotId'] == null ? undefined : json['snapshotId'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'versionId': json['versionId'] == null ? undefined : json['versionId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'status': json['status'] == null ? undefined : json['status'],
        'assignedOperatorId': json['assignedOperatorId'] == null ? undefined : json['assignedOperatorId'],
        'generatedAt': json['generatedAt'] == null ? undefined : (parseDateTime(json['generatedAt'])),
        'dueAt': json['dueAt'] == null ? undefined : (parseDateTime(json['dueAt'])),
        'completedAt': json['completedAt'] == null ? undefined : (parseDateTime(json['completedAt'])),
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(FormSectionResponseFromJSON)),
        'groups': json['groups'] == null ? undefined : ((json['groups'] as Array<any>).map(FormGroupResponseFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
    };
}

export function InspectionFormResponseToJSON(json: any): InspectionFormResponse {
    return InspectionFormResponseToJSONTyped(json, false);
}

export function InspectionFormResponseToJSONTyped(value?: InspectionFormResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'scheduleId': value['scheduleId'],
        'snapshotId': value['snapshotId'],
        'templateId': value['templateId'],
        'versionId': value['versionId'],
        'machineId': value['machineId'],
        'status': value['status'],
        'assignedOperatorId': value['assignedOperatorId'],
        'generatedAt': value['generatedAt'] == null ? value['generatedAt'] : serializeDateTime(value['generatedAt']),
        'dueAt': value['dueAt'] == null ? value['dueAt'] : serializeDateTime(value['dueAt']),
        'completedAt': value['completedAt'] == null ? value['completedAt'] : serializeDateTime(value['completedAt']),
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(FormSectionResponseToJSON)),
        'groups': value['groups'] == null ? undefined : ((value['groups'] as Array<any>).map(FormGroupResponseToJSON)),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
    };
}

